import React from 'react'
import { TextField } from '@mui/material'
import { ruleValidation } from './customFunctions'
import { makeStyles, withStyles } from '@mui/styles';

const CssTextField = withStyles({
    root: {
        //paddingTop:6,
      '& label.Mui-focused': {
        //color: 'green',
      },
      '& .MuiInput-underline:after': {
        //borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        //borderRadius:12,
        '& fieldset': {
          borderColor: '#4F4F4F',
        },
        '&:hover fieldset': {
          //borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          //borderColor: 'green',
        },
      },
    },
  })(TextField);

const InputForm = props => {

    const {data, onChange, startAdornment, endAdornment, onKeyUp, 
      onKeyDown, onKeyPress, forceUpperCase, inputProps, disabled} = props

    const onInnerChange = event => {
        const response = event.target.value;
        let temp = {...data};
        temp.value = response;
        temp.isValid = ruleValidation(temp.value, temp.rules, temp.value2);
        temp.isVisited = true;
        onChange(temp);
    } 

    const classes = useStyles()

    const {config, value, isValid, isVisited} = data

    const isError = isVisited && !isValid
    let interConfig = {...config}
    if(!isError) interConfig.helperText = ''


    return(
        <div>
            <CssTextField  value={value} variant='outlined'  onKeyPress={onKeyPress} disabled={disabled}
            error={isError} {...interConfig} onChange={onInnerChange} 
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={
                {
                    inputProps:{
                      className:classes.root,
                      style:forceUpperCase ? {textTransform:'uppercase'}: null,
                      ...inputProps
                    },
                    startAdornment:startAdornment ? startAdornment : undefined,
                    endAdornment:endAdornment ? endAdornment : undefined,
                    onKeyUp:onKeyUp ? onKeyUp : undefined,
                    onKeyDown:onKeyDown ? onKeyDown : undefined,
                }}
            />
        </div>
    )
}

const useStyles = makeStyles(theme => ({
  root:{
    '&:-webkit-autofill': {
      //transitionDelay:'9999s',
      WebkitBoxShadow: '0 0 0 1000px white inset',
    }
  }
}))

export default InputForm